import React from 'react';
import { useTranslation } from '../../../../../../hooks';
import styles from './Analytics.module.css';
import { Typography } from '@mui/material';

export const Limit = ({ limit }: { limit: number }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.limit}>
      <div>{t('limit')}</div>
      <Typography className={styles.limitAmount}>
        {Math.round(limit).toLocaleString('ru-RU')}
      </Typography>
    </div>
  );
};
